// extracted by mini-css-extract-plugin
module.exports = {"header-fullscreen-button":"header-fullscreen-button_header-fullscreen-button__jSq_I"};